<template>
    <v-card :loading="loading">
        <v-card-title>
            {{title}}
            <v-spacer></v-spacer>
            <!-- Reload Reserve -->
            <v-tooltip
                    top
                    color="primary"
                    content-class="caption iransans font-weight-medium px-3"
            >
                <template #activator="{on}">
                    <v-btn
                            icon
                            v-on="on"
                            small
                            @click="syncReport"
                    >
                        <v-icon :class="{ 'mdi-spin' : loading }">mdi-cached</v-icon>
                    </v-btn>
                </template>

                <span>{{$t('reload')}}</span>
            </v-tooltip>
        </v-card-title>
        <v-card-text>
            <Highcharts :options="chartOptions"/>
        </v-card-text>
    </v-card>
</template>

<script>
    import config from '@/config';
    import Service from '../services/UsersService';
    import Moment from 'moment-jalaali';

    import { Chart } from 'highcharts-vue';

    export default {
        components: {
            Highcharts: Chart
        },
        props: {
            filters: {
                default : () => []
            },
            title: {
                type: String
            }
        },
        async mounted() {
            await this.syncReport();
        },
        data() {
            return {
                chartOptions: {
                    chart: {
                        type: 'area'
                    },
                    title: {
                        text: null,
                        useHTML: true,
                        style: {
                            fontFamily: 'IRANSans',
                            fontWeight: 700
                        }
                    },
                    xAxis: {
                        categories: [
                        ],
                        labels: {
                            useHTML: true,
                            formatter() {
                                return Moment(this.value).format('jYYYY-jMM-jDD');
                            },
                            style: {
                                fontFamily: 'IRANSans',
                                fontWeight: 500
                            }
                        }
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: this.$t('count'),
                            useHTML: true,
                            style: {
                                fontFamily: 'IRANSans',
                                fontWeight: 700
                            }
                        },
                        labels: {
                            overflow: 'justify',
                            style: {
                                fontFamily: 'IRANSans',
                                fontWeight: 500
                            }
                        }
                    },
                    tooltip: {
                        useHTML: true,
                        style: {
                            fontFamily: 'IRANSans'
                        },
                        formatter() {
                            return `
                                <div class="text-center font-weight-bold mb-1"> ${Moment(this.x).format('jYYYY-jMM-jDD dddd')} </div>
                                ${this.series.name}: <b> ${this.y.toLocaleString('fa-IR')} </b> نفر
                            `;
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                enabled: true,
                                style: {
                                    fontFamily: 'IRANSans',
                                    fontSize: 13
                                }
                            }
                        }
                    },
                    legend: {
                        useHTML: true,
                        y: 15,
                        itemStyle: {
                            fontFamily: 'IRANSans',
                            top: 0
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    series: [
                        {
                            data: []
                        }
                    ]
                },
                loading: false,

                reservationStates: config.reservationStates,
                reports: [],
                locations: {}
            }
        },
        methods: {
            async syncReport() {
                this.loading = true;
                this.reports = [];
                try {
                    let {
                        data
                    } = await Service.getOverviewReport('daily', this.filters);
                    this.reports = data.value.users_overview;
                } finally {
                    this.loading = false;
                }
                this.updateChart();
            },
            updateChart(){
                let reports = {
                    name: this.$t('registered'),
                    userLabel: this.$t('user'),
                    data: []
                };
                let categories = [];
                this.reports.map((report) => {
                    categories.push([report.year,report.month, report.day].join('-'));
                    reports.data.push(parseInt(report.total));
                });
                this.chartOptions.xAxis.categories = categories;
                this.chartOptions.series = [reports];
            }
        }
    }
</script>